import { render, staticRenderFns } from "./HistoricalRacesTable.vue?vue&type=template&id=dda5acb2&scoped=true&"
import script from "./HistoricalRacesTable.vue?vue&type=script&lang=js&"
export * from "./HistoricalRacesTable.vue?vue&type=script&lang=js&"
import style0 from "./HistoricalRacesTable.vue?vue&type=style&index=0&id=dda5acb2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dda5acb2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
